const widget = document.querySelector('.gh-hr-functions');
const hrFunctions = widget.querySelectorAll('.row.description > span');
const hrFunctionsViews = widget.querySelectorAll('.row.views > .hr-functions-box');
let activeHrFunctionIndex = 0;

function onClickTitle(index) {
    if (!isNaN(activeHrFunctionIndex)) {
        hrFunctions.item(activeHrFunctionIndex)?.classList.remove('active');
        hrFunctionsViews.item(activeHrFunctionIndex)?.classList.remove('active');
    }

    hrFunctions.item(index)?.classList.add('active');
    hrFunctionsViews.item(index)?.classList.add('active');
    activeHrFunctionIndex = index;
}

hrFunctions.forEach((item, index) => {
    item.addEventListener('click', function () {
        onClickTitle(index);
    });
});
